import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import AuthenticIconNoBG from '../../../../images/authenticIconNoBG.png';
export default class Tagline extends Component{
    render(){
        return (
            <div className="tagline">
                <KickImage src={AuthenticIconNoBG} alt=""/>
                <span>
                        Authentic. Guaranteed.
                </span>
            </div>
        )
    }
}
